import { ApiClientService, EntityApiService } from '@dfl/react-security';
import { IImageMedia, IImageOption } from 'modules/common/interfaces';
import { MAX_SIZE_FILE } from 'settings/globals';

export class UploadService<T> extends EntityApiService<T> {
  upload = (path: string, file: File | undefined): Promise<IImageMedia> => {
    if (!file) {
      return Promise.reject({
        reference: 'no_file',
        error: 'You must need a files',
      });
    }

    if (file.size > MAX_SIZE_FILE) {
      return Promise.reject({
        reference: 'file-too-large',
        error: 'File size exceeds the maximum limit of 3MB',
        name: file.name,
      });
    }

    const formData = new FormData();
    formData.append('file', file as Blob);

    if (file) {
      return this.handleResponse(
        ApiClientService.post(this.getPath(path), formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }),
      );
    }

    return Promise.reject(new Error('You must need a userId and a files'));
  };

  uploadImageOption = (path: string, file: File | undefined, imageOption: IImageOption): Promise<IImageMedia> => {
    if (!file) {
      return Promise.reject({
        reference: 'no_file',
        error: 'You must need a files',
      });
    }

    if (file.size > MAX_SIZE_FILE) {
      return Promise.reject({
        reference: 'file-too-large',
        error: 'File size exceeds the maximum limit of 3MB',
        name: file.name,
      });
    }

    const formData = new FormData();
    formData.append('file', file as Blob);
    formData.append('imageOption', JSON.stringify(imageOption));

    if (file) {
      return this.handleResponse(
        ApiClientService.post(this.getPath(path), formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }),
      );
    }

    return Promise.reject(new Error('You must need a userId and a files'));
  };
}

export default new UploadService('/ms-auth/api/storage');
